/** Digits only, country code included. Matches the backend WhatsApp phone check. */
export function phoneDigits(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (digits.length < 8 || digits.length > 15) return null;
  return digits;
}

export function clientPhone(client) {
  return phoneDigits(client?.number || client?.phone || client?.mobile || client?.mobileNumber);
}

export function hasValidPhone(client) {
  return Boolean(clientPhone(client));
}

export function htmlToPlainText(html) {
  const raw = String(html || "");
  if (!raw.trim()) return "";
  const withBreaks = raw
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<\/li>/gi, "\n");
  const holder = document.createElement("div");
  holder.innerHTML = withBreaks;
  return (holder.textContent || "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export const WHATSAPP_CATEGORY_OPTIONS = [
  { label: "All clients with a valid number", value: "all" },
  { label: "Clients with Visa Expiry", value: "visaExpiry" },
  { label: "Clients with Birthday Today", value: "birthday" },
  { label: "Clients with Passport Expiry", value: "passportExpiry" },
];
